import { createStore } from './store';

export const defaultStore = createStore();
export default defaultStore;
